import React, { useRef } from 'react';
import { useFeatureFlag, useSubjectLanguageVariants } from '@features/user';
import { ContactPage as FormsIcon } from '@mui/icons-material';
import { useEventTracking } from '@services/statsig';

import {
  SendFormsSlidePanels,
  type SendFormsSlidePanelsHandle,
} from '../../../components/Forms/SendFormsSlidePanels';
import { ToolbarButton } from '../components/ToolbarButton';
import { useToolbarAction } from '../store/hooks';
import { type ToolbarActionProps } from '../types';

export const SendFormsAction: React.FC<ToolbarActionProps> = ({
  context,
  compact,
  presentation,
}) => {
  const isEnabled = useFeatureFlag('forms');
  const { badgeCount } = useToolbarAction('send-forms');
  const sendFormsRef = useRef<SendFormsSlidePanelsHandle>(null);
  const { singular: subjectLanguage } = useSubjectLanguageVariants();
  const { toolbar } = useEventTracking();

  // Only show if forms feature flag is enabled
  if (!isEnabled || !context?.patientId) return null;

  const handleClick = () => {
    toolbar.actionClicked({
      action_type: 'send_forms',
      has_patient: !!context?.patientId,
    });
    sendFormsRef.current?.open();
  };

  return (
    <>
      <ToolbarButton
        icon={FormsIcon}
        label="Forms"
        tooltip={`Send forms to ${subjectLanguage}`}
        onClick={handleClick}
        compact={compact}
        badgeCount={badgeCount}
        dataAttribute="toolbar-send-forms"
        presentation={presentation}
        menuLabel="Send form"
      />

      {/* Only render SendFormsSlidePanels if we have a patientId */}
      {context?.patientId && (
        <SendFormsSlidePanels ref={sendFormsRef} patientId={context.patientId} />
      )}
    </>
  );
};
